import { useState } from "react";
import PropTypes from "prop-types";
import Map from "react-map-gl";
import ModalMap from "components/shared/stays/ModalMap";
import LocationMapMarker from "components/stay/LocationMapMarker";
import styles from "components/stay/LocationMapModal.module.scss";

export default function LocationMapModal({
  latitude,
  longitude,
  showMarker,
  initialZoom,
  mapboxApiAccessToken,
  show,
  handleClose,
}) {
  const [viewState, setViewState] = useState({
    latitude,
    longitude,
    zoom: initialZoom,
  });

  return (
    <ModalMap show={show} handleClose={handleClose}>
      <div className={styles.component}>
        <Map
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...viewState}
          onMove={(evt) => setViewState(evt.viewState)}
          style={{ width: "100%", height: "100%" }}
          mapStyle="mapbox://styles/rteuscher/cksygrnfkxye917p6gsc8qlt7"
          mapboxAccessToken={mapboxApiAccessToken}
          onRender={(event) => event.target.resize()}
          attributionControl={false}
        >
          {showMarker && (
            <LocationMapMarker latitude={latitude} longitude={longitude} />
          )}
        </Map>
      </div>
    </ModalMap>
  );
}

LocationMapModal.propTypes = {
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  showMarker: PropTypes.bool.isRequired,
  initialZoom: PropTypes.number.isRequired,
  mapboxApiAccessToken: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
